import FormSectionTitle from "../../components/styled/FormSectionTitle";
import MoneyReceiptSection from "./MoneyReceiptSection";

export default function CustomerField({ watch, control, errors, setValue }) {
  const fields = [
    {
      label: "Name",
      name: "customer.name",
      type: "text",
      placeholder: "Name",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Mobile",
      name: "customer.mobile",
      type: "text",
      placeholder: "Mobile",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Email",
      name: "customer.email",
      type: "text",
      placeholder: "Email",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Designation",
      name: "customer.designation",
      type: "text",
      placeholder: "Designation",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Address",
      name: "customer.address",
      type: "textarea",
      placeholder: "Address",
      col: { md: 12 }
    }
  ];

  const isLoading = false;

  return (
    <MoneyReceiptSection
      setValue={setValue}
      fields={fields}
      control={control}
      watch={watch}
      errors={errors}
      loading={isLoading}>
      <div className="col-12">
        <FormSectionTitle>Customer Information</FormSectionTitle>
      </div>
    </MoneyReceiptSection>
  );
}
